__turbopack_context__.v({
  "toggle": "Toggle-module-scss-module__M9Fk8a__toggle",
  "toggleDisabled": "Toggle-module-scss-module__M9Fk8a__toggleDisabled",
});
